import { useEffect, useState } from "react";
import { Users, CalendarDays, Images, ScanFace, DollarSign, HardDrive } from "lucide-react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import api from "@/lib/api";
import { Loader } from "@/components/common/Loader";
import { PageHeader, StatCard } from "@/components/dashboard/ui";

const COLORS = ["#d4af37", "#8a6d1f", "#e8d6a8"];

export default function AdminDashboard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return <Loader />;
  const plan = Object.entries(s.by_plan).map(([k, v]) => ({ name: k, value: v }));

  return (
    <div>
      <PageHeader title="Platform Overview" subtitle="Everything happening across PMR Events." />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard icon={Users} label="Photographers" value={s.photographers} accent sub={`${s.active_photographers} active`} />
        <StatCard icon={DollarSign} label="MRR" value={`$${s.mrr.toLocaleString()}`} accent />
        <StatCard icon={CalendarDays} label="Total Events" value={s.events} />
        <StatCard icon={Images} label="Total Photos" value={s.photos.toLocaleString()} />
        <StatCard icon={ScanFace} label="Face Searches" value={s.searches.toLocaleString()} />
        <StatCard icon={HardDrive} label="Storage" value={`${s.storage_gb} GB`} />
      </div>

      <div className="grid lg:grid-cols-3 gap-4 mt-4">
        <div className="rounded-2xl border border-border bg-black/40 p-6">
          <div className="text-white font-medium mb-4">Plan distribution</div>
          <ResponsiveContainer width="100%" height={220}>
            <PieChart>
              <Pie data={plan} dataKey="value" nameKey="name" innerRadius={55} outerRadius={90} paddingAngle={3}>
                {plan.map((e, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
              </Pie>
              <Tooltip contentStyle={{ background: "#111", border: "1px solid #262626", borderRadius: 12, color: "#fff", textTransform: "capitalize" }} />
            </PieChart>
          </ResponsiveContainer>
          <div className="flex justify-center gap-4 mt-2">
            {plan.map((p, i) => <div key={p.name} className="flex items-center gap-1.5 text-xs text-muted-foreground capitalize"><span className="w-2.5 h-2.5 rounded-full" style={{ background: COLORS[i % COLORS.length] }} />{p.name} ({p.value})</div>)}
          </div>
        </div>
        <div className="lg:col-span-2 rounded-2xl border border-gold/20 bg-gradient-to-r from-gold/5 to-transparent p-6 flex flex-col justify-center">
          <div className="text-xs uppercase tracking-wider text-gold">Monthly recurring revenue</div>
          <div className="font-serif text-6xl text-white mt-2">${s.mrr.toLocaleString()}</div>
          <p className="text-sm text-muted-foreground mt-3">Across {s.active_photographers} active studios on paid plans. Manage accounts and subscriptions from the Photographers tab.</p>
        </div>
      </div>
    </div>
  );
}
